// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","inlineButtons":"styles_inlineButtons__b7KXe"};